import type { UnitListMode } from './types';

export interface UnitsCapabilities {
  listMode: UnitListMode;
  canSwitchListMode: boolean;
  canCreate: boolean;
  canPin: boolean;
  canShowArchived: boolean;
  showAssignedStaff: boolean;
  canManageStudents: boolean;
  canManageGames: boolean;
  canManageActivities: boolean;
  canViewActivityResponses: boolean;
  canViewMarkbook: boolean;
  canEditMetadata: boolean;
  canArchiveRestore: boolean;
  canManageAssignedStaff: boolean;
  canPermanentlyDelete: boolean;
}

export const teacherUnitsCapabilities: UnitsCapabilities = {
  listMode: 'assigned',
  canSwitchListMode: false,
  canCreate: true,
  canPin: true,
  canShowArchived: false,
  showAssignedStaff: false,
  canManageStudents: true,
  canManageGames: true,
  canManageActivities: true,
  canViewActivityResponses: true,
  canViewMarkbook: true,
  canEditMetadata: false,
  canArchiveRestore: false,
  canManageAssignedStaff: true,
  canPermanentlyDelete: true,
};

export const librarianUnitsCapabilities: UnitsCapabilities = {
  listMode: 'org',
  canSwitchListMode: false,
  canCreate: true,
  canPin: false,
  canShowArchived: true,
  showAssignedStaff: true,
  canManageStudents: true,
  canManageGames: false,
  canManageActivities: false,
  canViewActivityResponses: true,
  canViewMarkbook: true,
  canEditMetadata: true,
  canArchiveRestore: true,
  canManageAssignedStaff: true,
  canPermanentlyDelete: true,
};
